// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lQIt","fullView":"styles_fullView__3ilaF"};